import { env } from '@ui/environment';
import { axios } from '@ui/http';
/** Exchange OAuth authorization code for access and refresh tokens */ export async function exchangeAuthCode(zeAuthCode) {
    const tokenUrl = new URL('/api/access-token', env.PUBLIC_AUTH_API_BASE_URL);
    tokenUrl.searchParams.set('ze_auth_code', zeAuthCode);
    const response = await axios.get(tokenUrl.toString());
    return response.data;
}
/** Fetch user info from auth service */ export async function fetchUserInfo() {
    const userInfoUrl = new URL('/api/userinfo', env.PUBLIC_AUTH_API_BASE_URL);
    const response = await axios.get(userInfoUrl.toString());
    return response.data.user_info;
}
/** Get OAuth login URL from auth service */ export async function getLoginUrl(state) {
    const authUrl = new URL('/api/authorize-link', env.PUBLIC_AUTH_API_BASE_URL);
    const originUrl = new URL('/auth/callback', window.location.origin).toString();
    authUrl.searchParams.set('origin_url', originUrl);
    authUrl.searchParams.set('state', state);
    const response = await axios.get(authUrl.toString());
    return response.data;
}
